import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  GET_ACTIVE_CHAINS,
  GET_ON_HOLD_CHAINS,
  GET_PENDING_CHAINS,
  SET_LOADER,
} from "../../types";
import { setErrors } from "../errorActions";

export const admin_get_active_chains_vendor =
  (token, status, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let results = await axios.get(
        // http://localhost:443/admin/restaurantchain?status=NOTAPPROVED&startDate=2020-09-05&endDate=2020-09-05
        `${serverApi}/admin/restaurantchain?status=${status}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (results.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        if (status === "APPROVED") {
          dispatch({
            type: GET_ACTIVE_CHAINS,
            payload: results.data,
          });
        } else if (status === "NOTAPPROVED") {
          dispatch({
            type: GET_PENDING_CHAINS,
            payload: results.data,
          });
        } else if (status === "ONHOLD") {
          dispatch({
            type: GET_ON_HOLD_CHAINS,
            payload: results.data,
          });
        }
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_change_active_chains_vendor =
  (token, restaurant_id, formData, onSuccess) => async (dispatch) => {
    try {
      let results = await axios.patch(
        `${serverApi}/admin/restaurantchain/${restaurant_id}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (results.status === 200) {
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_add_rest_chain_vendor =
  (formData, token, onSuccess) => async (dispatch) => {
    try {
      let results = await axios.post(
        `${serverApi}/admin/restaurantchain`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (results.status === 201) {
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
